import { useState } from 'react';
import { countries, countryName } from '../../../../shared/countries.ts';
import { api } from '../apiClient.ts';
import type { Page, SocialAccount } from '../types.ts';

export function SocialBadge({id, name}: {id:string;name?:string|null}) {
  return <span className="badge badge--currency" title={`Соц акаунт: ${name || id} · ${id}`}>{name || id}</span>;
}
export function OwnerBadge({id, accounts}: {id:string;accounts:SocialAccount[]}) {
  return <SocialBadge id={id} name={accounts.find(account=>account.id===id)?.name}/>;
}
export function GeoBadges({codes}: {codes?:string[]}) {
  return <>{codes?.map(code=><span key={code} className="badge badge--currency">GEO: {countryName(code)}</span>)}</>;
}
export function PageGeo({page, onSaved,disabled=false}: {page:Page;onSaved:(page:Page)=>void;disabled?:boolean}) {
  const [busy,setBusy]=useState(false),[error,setError]=useState('');
  return <div onClick={e=>e.stopPropagation()}>
    <select className="input page-geo-select" style={{background:'var(--color-surface)',color:'var(--color-text)',width:'auto'}} aria-label={`GEO сторінки ${page.name || page.id}`} value={page.geoCountry ?? ''} disabled={busy || disabled}
      onChange={async e=>{
        const geoCountry=e.target.value || null;
        setBusy(true);setError('');
        try { onSaved(await api.put<Page>(`/api/pages/${encodeURIComponent(page.id)}/geo`,{geoCountry})); }
        catch(error) {setError(error instanceof Error?error.message:'Не вдалося зберегти GEO.');}
        finally {setBusy(false);}
      }}>
      <option value="">GEO: не задано</option>
      {countries.map(country=><option style={{background:'var(--color-surface)',color:'var(--color-text)'}} key={country.code} value={country.code}>{country.name}</option>)}
    </select>
    {error && <span role="alert" className="text-error">{error}</span>}
  </div>;
}
